import { handleActions } from 'redux-actions'
import { Record, Map } from 'immutable'

import { companyStatsRequest } from './actions'

export const CompanyStats = Record({
  pending: false,
  data: Map(),
})

const fetchCompanyStatsRequest = state => {
  return state.set('pending', true)
}

const fetchCompanyStatsSuccess = (state, { payload: { data } }) => {
  return state.set('data', Map(data)).set('pending', false)
}

const fetchCompanyStatsFail = (state, { paylolad }) => {
  return state.set('pending', false)
}

export default handleActions(
  {
    [companyStatsRequest]: fetchCompanyStatsRequest,
    [companyStatsRequest.success]: fetchCompanyStatsSuccess,
    [companyStatsRequest.fail]: fetchCompanyStatsFail,
  },
  new CompanyStats()
)
